import { render, staticRenderFns } from "./orderCard.vue?vue&type=template&id=8f7987bc&scoped=true&"
import script from "./orderCard.vue?vue&type=script&lang=js&"
export * from "./orderCard.vue?vue&type=script&lang=js&"
import style0 from "./orderCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./orderCard.vue?vue&type=style&index=1&id=8f7987bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7987bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCol,VIcon,VRow,VSimpleTable})
